import React from "react";
import { SvgIcon } from "@material-ui/core";

/**
 * Ícono award (Figma barra-de-contacto · Emergencias).
 * Stroke 2, viewBox 32×32.
 */
const StarOfLife = props => (
  <SvgIcon viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M20.6363 17.1851L22.6563 28.5531C22.6789 28.6869 22.6602 28.8245 22.6025 28.9474C22.5448 29.0703 22.451 29.1727 22.3336 29.2408C22.2161 29.3089 22.0807 29.3396 21.9454 29.3287C21.8101 29.3178 21.6813 29.2658 21.5763 29.1797L16.803 25.5971C16.5726 25.4249 16.2926 25.3319 16.005 25.3319C15.7173 25.3319 15.4374 25.4249 15.207 25.5971L10.4257 29.1784C10.3207 29.2643 10.1921 29.3162 10.057 29.3271C9.92182 29.338 9.78655 29.3075 9.6692 29.2395C9.55186 29.1716 9.45802 29.0695 9.40021 28.9468C9.3424 28.8242 9.32337 28.6868 9.34565 28.5531L11.3643 17.1851M24 10.6655C24 15.0838 20.4183 18.6655 16 18.6655C11.5817 18.6655 8 15.0838 8 10.6655C8 6.24725 11.5817 2.66553 16 2.66553C20.4183 2.66553 24 6.24725 24 10.6655Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </SvgIcon>
);

export default StarOfLife;
